import React from 'react'

export default function languages() {
  return (
    <div style={{display : 'flex' , justifyContent : 'center' , flexWrap : 'wrap' }} >

<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/306px-ISO_C%2B%2B_Logo.svg.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px' }} />

<img src="https://www.pngitem.com/pimgs/m/31-312155_c-programming-language-logo-hd-png-download.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

<img src="https://www.guru99.com/images/python_tutorial.png" alt="img" style={{width : '280px' , height : '150px' , margin : '20px'}} />

<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/2048px-Unofficial_JavaScript_logo_2.svg.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />


    </div>
  )
}
